(function (window, document, cookieConsentName, legacyCookieName, dataLayerName) {
  const cookieConsent = window[cookieConsentName].consent;
  const cookieConsentBanner = window[cookieConsentName].banner;
  const { options } = cookieConsent;
  const regExp = new RegExp(`(?:(?:^|.*;\\s*)${legacyCookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`);
  const timestamp = document.cookie.replace(regExp, '$1');

  if (timestamp && !cookieConsent.get()) {
    const consent = {};

    for (const i in options) {
      consent[options[i]] = true;
    }

    cookieConsent.set(consent);
  }

  if (!cookieConsent.get()) {
    window[dataLayerName] = window[dataLayerName] || [];
    window[dataLayerName].push({ event: `${cookieConsentName}.showBanner` });
    cookieConsentBanner.show();
  }
}(window, document, 'cookieConsent', 'CookieDialog_agreed', 'dataLayer'));
